import dynamic from 'next/dynamic';

const FeatureDestination = dynamic(() => import('./FeatureDestination'));

export default FeatureDestination;
